import React, { useEffect } from "react";

import _ from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Carousel, Result } from "antd";

import { UserRoute } from "../../../routes";
import { RootState } from "../../../store/root_reducer";
import { fetchRequest } from "../../../store/widgets/filtered_airlines/actions";
import { Widget } from "../widget";

import styles from "./styles.module.scss";

export interface FilteredAirlinesWidgetProps {
  className?: string;
  chunkSize?: number;
}

export const FilteredAirlinesWidget: React.FC<FilteredAirlinesWidgetProps> = ({ className, chunkSize = 4 }) => {
  const { t } = useTranslation("filtered_airlines_widget");

  const selectedGate = useSelector((state: RootState) => state.User.selectedGate);
  const widgetState = useSelector((state: RootState) => state.Widgets.FilteredAirlines);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchRequest({ gateId: selectedGate.id }));
  }, [dispatch, selectedGate]);

  return (
    <Widget
      className={className}
      isLoading={widgetState.isLoading}
      title={
        <Link to={`${UserRoute.AirlinesProductivity}?status=low`} className={styles.title}>
          {t("title")}
        </Link>
      }
      helpText={t("helpText")}
      lastUpdated={moment.utc(widgetState.lastUpdated)}
    >
      {widgetState.items.length > 0 ? (
        <Carousel className={styles.carousel} dots={{ className: styles.dots }} autoplay pauseOnHover>
          {_.chunk(widgetState.items, chunkSize).map((items: string[], idx) => (
            <div key={idx}>
              {items.map((airline, index) => (
                <Link to={`${UserRoute.AirlinesProductivity}?search=${airline}`} className={styles.item} key={airline}>
                  <div>
                    <img
                      className={styles.logo}
                      alt={airline}
                      src={`https://pics.avs.io/al_square/96/96/${airline}@2x.png`}
                    />
                    <div className={styles.airline}>{airline}</div>
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </Carousel>
      ) : (
        <Result className={styles.result} status="success" title={t("emptyAirlines")} />
      )}
    </Widget>
  );
};
